// extracted by mini-css-extract-plugin
export var arrow = "L_9";
export var career = "L_cY";
export var careerContainer = "L_cX";
export var container = "L_b";
export var link = "L_bx";
export var location = "L_cZ";
export var section = "L_d";
export var title = "L_h";